module.exports = __webpack_public_path__ + "static/img/file-red.bb31b26e.svg";